import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esMX from "./es-MX.json";
import enUS from "./en-US.json";

const STORAGE_KEY = "dcc_lang";
const saved = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      "es-MX": { translation: esMX },
      "en-US": { translation: enUS },
    },
    lng: saved || "es-MX",
    fallbackLng: "es-MX",
    interpolation: { escapeValue: false },
  });

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  try { window.localStorage.setItem(STORAGE_KEY, lng); } catch (_) {}
}

export default i18n;
